import { Coach } from "./coach";
import { Athlete } from "./athlete";

interface TeamData {
  id: number;
  name: string;
  description: string;
  organizationId: number;
  createDate: string;
  createrId: number;
  updateDate: string;
  updaterId: number;
  deleteDate: string;
  deleterId: number;

  rights?: string[];

  coaches?: Coach[];
  athletes?: Athlete[];
}

export class Team{
  public static getNonTranslatableFields(): string[] { return ['id', 'name', 'description', 'organizationId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'name', 'description', 'organizationId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  public id: number;
  public name: string;
  public description: string;
  public organizationId: number;
  public createDate: string;
  public createrId: number;
  public updateDate: string;
  public updaterId: number;
  public deleteDate: string;
  public deleterId: number;

  rights?: string[];

  coaches?: Coach[];
  athletes?: Athlete[];

  public static fromAPI(data: TeamData): Team {
    if (data.coaches) {
      data.coaches = data.coaches.map((item: Coach) => Coach.fromAPI(item));
    }
    if (data.athletes) {
      data.athletes = data.athletes.map((item: Athlete) => Athlete.fromAPI(item));
    }
    return new Team(data);
  }

  public static fromAPIList(data: TeamData[]): Team[] {
    return data.map((item: TeamData) => Team.fromAPI(item));
  }

  constructor({id, name, description, organizationId, createDate, createrId, updateDate, updaterId, deleteDate, deleterId,
                rights, coaches, athletes} : TeamData) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.organizationId = organizationId;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;
    this.rights = rights;
    this.coaches = coaches;
    this.athletes = athletes;
  }

  public toJson(): Object {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      organizationId: this.organizationId,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId
    };
  }

}
